import React from 'react';
import { motion } from 'framer-motion';
import { SearchIcon, ArrowRightLeftIcon, RotateCcwIcon, TrendingUpIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { METHOD_STEPS } from './salesData';
const ICONS = [SearchIcon, ArrowRightLeftIcon, RotateCcwIcon, TrendingUpIcon];
export function MethodSection() {
  return <section id="metodo" className="bg-charcoal py-12 sm:py-16" data-id="element-245" data-mp="3uzuerm0svfhh">
      <div className="mx-auto max-w-5xl px-5" data-id="element-246" data-mp="vj5ychxoi5ep">
        <div className="text-center" data-id="element-247" data-mp="vl0kfzkos3kd">
          <SectionTag className="border-gold/50 bg-charcoal-soft text-gold-soft" data-id="element-248" data-mp="qjb72d9zrdt4">
            El método
          </SectionTag>
          <h2 className="mt-4 font-display text-[1.45rem] font-bold uppercase leading-tight text-ivory sm:text-[2.1rem]" data-id="element-249" data-mp="lrryua5q95lk">
            Detectar · Convertir
            <span className="mt-1 block text-gold" data-id="element-250" data-mp="1e95gslz0km95">Recuperar · Rentabilizar</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl font-sans text-[0.9rem] leading-relaxed text-ivory/70 sm:text-base" data-id="element-251" data-mp="19ixg8trbg5xz">
            Cuatro etapas en orden. Cada una se apoya en la anterior y se implementa sobre el
            consultorio que ya tenés funcionando hoy.
          </p>
        </div>

        <div className="mt-8 grid gap-3 sm:grid-cols-2 lg:grid-cols-4" data-id="element-252" data-mp="1lcfklh46mpjp">
          {METHOD_STEPS.map((step, i) => {
          const Icon = ICONS[i % ICONS.length];
          return <motion.article key={step.num} initial={{
            opacity: 0,
            y: 14
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-40px'
          }} transition={{
            duration: 0.35,
            delay: i * 0.06
          }} className="h-full rounded-2xl border border-ivory/15 bg-charcoal-soft/60 p-5" data-id="element-253" data-mp="1q95zw285xh42" data-mpi={i}>
                <div className="flex items-center justify-between" data-id="element-254" data-mp="17ehj3caymnlm">
                  <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-gold/15" data-id="element-255" data-mp="2ws46s69m3kjg">
                    <Icon className="h-4 w-4 text-gold" aria-hidden data-id="element-256" data-mp="31q5pur71fjux" />
                  </span>
                  <span className="font-sans text-[0.62rem] font-bold uppercase tracking-editorial tabular-nums text-ivory/40" data-id="element-257" data-mp="30abelc0qav3d">
                    {step.num}
                  </span>
                </div>
                <h3 className="mt-3.5 font-display text-[1.05rem] font-bold uppercase leading-tight text-ivory" data-id="element-258" data-mp="2qbuk452kzyck">
                  {step.name}
                </h3>
                <p className="mt-1.5 font-sans text-[0.82rem] leading-relaxed text-ivory/65" data-id="element-259" data-mp="3j0jgjqsozfhz">
                  {step.desc}
                </p>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}